<template>
<p>{{$tf('expire_session.message',{count})}}</p>
</template>

<script>
import bus from '~/bus'
export default {
  name: 'DialogExpireSession',
  data: () => ({
    count: 20,
    startingCount: 20
  }),
  mounted () {
    bus.$on('continue-session', this.continueSession)
    this.countDown = setInterval(async () => {
      this.count--
      if (this.count < 1 && this.$idle.idle) {
        this.$store.dispatch('dialog/clearQueue')
        this.$store.dispatch('dialog/closeDialog')
        try {
          await this.$store.dispatch('session/destroySession')
        } finally {
          window.location.reload()
        }
        clearInterval(this.countDown)
        console.log(this.$tf('expire_session.logged_out.log', {count: this.$config.expireSessionTime}))
        this.$store.dispatch('dialog/showDialog', {
          title: this.$tf('expire_session.logged_out.title'),
          body: this.$tf('expire_session.logged_out.message'),
          persistent: false,
          width: 480,
          actions: {
            accept: {
              title: 'Close'
            }
          }
        })
      }
      if (this.count < 0) {
        this.count = this.startingCount
        clearInterval(this.countDown)
      }
    }, 1000)
  },
  methods: {
    continueSession () {
      this.$store.dispatch('dialog/closeDialog')
      clearInterval(this.countDown)
      this.count = this.startingCount
    }
  },
  beforeDestroy () {
    bus.$off('continue-session', this.continueSession)
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/dialog/types/DialogExpireSession.vue